"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["src", "priority", "loading", "decoding", "quality", "sizes", "alt"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useAgImageServerUrl } from '@autoguru/image-server-config';
import Head from 'next/head';
import { forwardRef } from 'react';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const SimpleNextPicture = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      src: incomingSrc,
      priority = false,
      loading = 'lazy',
      decoding = 'async',
      quality = 60,
      sizes = '100vw',
      alt = ''
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    srcset,
    src
  } = useAgImageServerUrl({
    url: typeof incomingSrc === 'string' ? incomingSrc : '',
    quality
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [priority ? /*#__PURE__*/_jsx(Head, {
      children: /*#__PURE__*/_jsx("link", {
        rel: "preload",
        as: "image",
        imageSrcSet: srcset,
        imageSizes: sizes
      })
    }) : null, /*#__PURE__*/_jsx("img", _objectSpread({
      ref: ref,
      loading: priority ? 'eager' : loading,
      decoding: priority ? 'sync' : decoding,
      src: src,
      srcSet: srcset,
      sizes: sizes,
      alt: alt
    }, props))]
  });
});
export default SimpleNextPicture;